/** @format */

import template from './gb-add-countdown-widget.html';

import moment from 'moment';
import 'moment-timezone';

export const GbAddCountdownWidgetComponent = {
    template,
    require: {
        gbPresenter: '^^',
        gbApp: '^^',
    },
    bindings: {
        widget: '=',
    },
    controller: class GbAddCountdownWidgetComponent {
        constructor($gbCountdownProjectorWidget) {
            'ngInject';

            this.$gbCountdownProjectorWidget = $gbCountdownProjectorWidget;
        }

        getWidget() {
            return this.widget;
        }

        getAuction() {
            return this.gbApp.getAuction();
        }

        getTimezone() {
            return this.getAuction().timezone;
        }

        getAuctionDate() {
            let auctionStart = moment(this.getAuction().start, this.getTimezone());

            return new Date(auctionStart);
        }

        getEndTime() {
            let momentEnd = moment(new Date(), this.getTimezone()).format('YYYY-MM-DDTHH:mm:ssZ');
            this.end = new Date(momentEnd);
            this.end.setHours(this.end.getHours() + 2);
            this.end.setMilliseconds(0);
            this.end.setSeconds(0);

            if (this.getAuctionDate() > this.end) {
                let newEnd = new Date(this.getAuctionDate());
                newEnd.setHours(this.end.getHours());
                newEnd.setMinutes(this.end.getMinutes());

                this.end = newEnd;
            }

            return this.end;
        }

        addWidget() {
            let widget = new this.$gbCountdownProjectorWidget({
                opacity: 1,
                width: null,
                width_unit: '%',
                height: null,
                height_unit: '%',
                x: 50,
                y: 50,
                x_unit: '%',
                y_unit: '%',
                font_size: 21,
                timezone: this.getTimezone(),
                end: this.getEndTime(),
            });

            this.gbPresenter.tempWidgets.push(widget);
        }
    },
};
